import { render, staticRenderFns } from "./ConfigPersonIdGeneralProperties.vue?vue&type=template&id=7d480fe2&scoped=true&"
import script from "./ConfigPersonIdGeneralProperties.vue?vue&type=script&lang=js&"
export * from "./ConfigPersonIdGeneralProperties.vue?vue&type=script&lang=js&"
import style0 from "./ConfigPersonIdGeneralProperties.vue?vue&type=style&index=0&id=7d480fe2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d480fe2",
  null
  
)

export default component.exports